var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.782,
    height: 16,
    viewBox: "0 0 10.782 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    transform: "translate(-10.123 -5.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M17.645,7.875a.77.77,0,0,1,.77.77v13.86a.77.77,0,1,1-1.54,0V8.645A.77.77,0,0,1,17.645,7.875Z",
    transform: "translate(-2.131 -1.652)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M14.969,5.85a.77.77,0,0,1,1.09,0l4.62,4.62a.771.771,0,1,1-1.09,1.09L15.514,7.483l-4.075,4.076a.771.771,0,1,1-1.09-1.09l4.62-4.62Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_up.ed4e2534f73dcee1c3e37a7c9271c69d.svg";